
import Vue from "vue";
import { getCurrentUser } from "./auth";
import Header from "./layouts/Header.vue";
export default Vue.extend({
  name: "App",
  data: () => ({}),
  components: {
    Header,
  },
  computed: {
    isAuthenticated() {
      return getCurrentUser();
    },
  },
});
